import {createAction, props} from '@ngrx/store';
import {ReuseBelegData} from '../../interfaces/reuse-beleg-data.interface';

export class ReuseBelegDialogActions {
  public static open = createAction(
    '[Overview- & Edit-Page] Open reuse-beleg-dialog.',
    props<{
      data: ReuseBelegData;
    }>(),
  );

  public static close = createAction('[Reuse-Beleg-Dialog] Close reuse-beleg-dialog.');
}
